import { IVenda } from "shared/interfaces/IVenda";
import { api } from "../api";

export async function buscarVendasPorUsuario(): Promise<IVenda[]> {
  try {
    // v2: cada item traz a combinação e os SKUs vendidos.
    const response = await api.get("/v2/orders/mine/sales");

    return (response.data ?? []).map((venda: any) => {
      const item = venda.items?.[0];

      const status =
        venda.status === "PENDING"
          ? "Pendente"
          : venda.status === "PAID"
          ? "Pago"
          : venda.status === "SHIPPED"
          ? "Enviado"
          : venda.status === "DELIVERED"
          ? "Entregue"
          : venda.status === "CANCELED"
          ? "Cancelado"
          : venda.status;

      return {
        ...venda,

        status,

        name: item?.productName ?? "Produto",

        total: Number(venda.totalAmount ?? 0),

        subtotal: Number(venda.subtotal ?? 0),

        shipping: Number(venda.shipping ?? 0),

        interest: Number(venda.interest ?? 0),

        discount: Number(venda.discount ?? 0),

        images: venda.images ?? [],

        thumbnailUrl: venda.thumbnailUrl,

        paymentMethod: venda.paymentMethod,

        paymentDetails: venda.paymentDetails,

        data: venda.createdAt ?? "",
      };
    });
  } catch (error) {
    return [];
  }
}